// src/pages/Home.js
import React from 'react';

const ContactUs = () => (
  <div className="page">
    <div class="row justify-content-center">
        <div class="col-md-8 text-center">
            <h1 class="mb-4">تواصل معنا</h1>
            <p class="lead">نرحب بتواصلكم! لا تترددوا في الوصول إلينا باستخدام التفاصيل أدناه.</p>
            <div class="card shadow-sm mt-4">
                <div class="card-body">
                    <p class="mb-2"  dir="ltr">
                        <i class="bi bi-telephone-fill"></i> 
                        +964 7770575133
                    </p>
                    <p>
                        <i class="bi bi-envelope-fill"></i> 
                        support@aullan.com
                    </p>
                </div>
            </div>
            <p class="m-2"><a class="btn btn-primary" href="/">العودة للواجهة الرئيسية</a></p>
        </div>
    </div>
  </div>
);

export default ContactUs;
